<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <p>
      For a guide and recipes on how to configure / customize this project,<br>
      check out the
      <a href="/" rel="noopener">首页</a>.
    </p>
    <h3>100以内加减法</h3>
    <ul>
      <li><a href="#" @click="dl('/dl/add_1_100')" target="_blank" rel="noopener">100道加法</a></li>
      <li><a href="#" @click="dl('/dl/sub_1_100')" target="_blank" rel="noopener">100道减法</a></li>
      <li><a href="#" @click="dl('/dl/add_or_sub_1_100')" target="_blank" rel="noopener">100道混合加减法</a></li>
      <li><a href="#" @click="dl('/dl/sub_borrow_1_100')" target="_blank" rel="noopener">100道借位法</a></li>
      <li><a href="#" @click="dl('/dl/add_or_sub_1_100_20')" target="_blank" rel="noopener">20道加减法列算式</a></li>
    </ul>
    <h3>乘法口算</h3>
    <ul>
      <li><a href="#" @click="dl('/dl/multi')" target="_blank" rel="noopener">100道9x9乘法口算</a></li>
      <li><a href="#" @click="dl('/dl/multi_add_and_sub')" target="_blank" rel="noopener">100道加减法乘法混合口算</a></li>
      <li><a href="#" @click="dl('/dl/multi_add_and_sub_sort2')" target="_blank" rel="noopener">100道法乘法与加减法混合规则口算</a></li>
    </ul>
    <h3>Essential Links</h3>
    <ul>
      <li><a href="https://vuejs.org" target="_blank" rel="noopener">Core Docs</a></li>
      <li><a href="https://forum.vuejs.org" target="_blank" rel="noopener">Forum</a></li>
      <li><a href="https://chat.vuejs.org" target="_blank" rel="noopener">Community Chat</a></li>
      <li><a href="https://twitter.com/vuejs" target="_blank" rel="noopener">Twitter</a></li>
      <li><a href="https://news.vuejs.org" target="_blank" rel="noopener">News</a></li>
    </ul>
    <h3>Ecosystem</h3>
    <ul>
      <li><a href="https://router.vuejs.org" target="_blank" rel="noopener">vue-router</a></li>
      <li><a href="https://vuex.vuejs.org" target="_blank" rel="noopener">vuex</a></li>
      <li><a href="https://github.com/vuejs/vue-devtools#vue-devtools" target="_blank" rel="noopener">vue-devtools</a></li>
      <li><a href="https://vue-loader.vuejs.org" target="_blank" rel="noopener">vue-loader</a></li>
      <li><a href="https://github.com/vuejs/awesome-vue" target="_blank" rel="noopener">awesome-vue</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  methods:{

    dl(path){

       const filePath  = path+"?timestamp=" + new Date().getTime()
       window.open(filePath)
    }
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
